import { createRouter, createWebHashHistory } from 'vue-router'
import NotFound from '../views/notfound/NotFound.vue'
import AdminHome from '../views/AdminPage/home.vue'

import Adduser from '../views/AdminPage/user/adduser.vue'
import listuser from '../views/AdminPage/user/listuser.vue'

import Listgift from '../views/AdminPage/gift/giftlist.vue'
import Addgift from '../views/AdminPage/gift/giftadd.vue'

import Listintegral from '../views/AdminPage/integral/integrallist.vue'
import Addintegral from '../views/AdminPage/integral/integraladd.vue'

import Listmessage from '../views/AdminPage/message/messagelist.vue'
import Addmessage from '../views/AdminPage/message/messageadd.vue'

import Listsong from '../views/AdminPage/song/songlist.vue'
import Addsong from '../views/AdminPage/song/songadd.vue'
import Classsong from '../views/AdminPage/song/songclass.vue'


import Listshop from '../views/AdminPage/shop/shoplist.vue'
import Addshop from '../views/AdminPage/shop/shopadd.vue'

import Pagesetting from '../views/AdminPage/setting/Page.vue'
import Titlesetting from '../views/AdminPage/setting/Title.vue'
import BilibiliLogin from '../views/AdminPage/setting/BilibiliLogin.vue'

import Feedback from '../views/AdminPage/Feedback/Feedback.vue'

import Exchange from '../views/AdminPage/Exchange/Exchange.vue'

import Blackadd from '../views/AdminPage/black/blackadd.vue'
import Blacklist from '../views/AdminPage/black/blacklist.vue'

import lampadd from '../views/AdminPage/lamp/lampadd.vue'
import lamplist from '../views/AdminPage/lamp/lamplist.vue'
const routes = [



    //管理页面
    //首页设置url
    {
        path: "/admin/index",
        name: "AdminHome",
        component: AdminHome,
    },
    //用户
    {
        path: "/admin/user-manage/Adduser",
        component: Adduser
    },
    {
        path: "/admin/user-manage/listuser",
        component: listuser
    },
    //礼物
    {
        path: "/admin/gift/list",
        component: Listgift
    },
    {
        path: "/admin/gift/add",
        component: Addgift
    },
    //积分
    {
        path: "/admin/integral/list",
        component: Listintegral
    },
    {
        path: "/admin/integral/add",
        component: Addintegral
    },
    //留言
    {
        path: "/admin/message/list",
        component: Listmessage
    },
    {
        path: "/admin/message/add",
        component: Addmessage
    },
    //歌单
    {
        path: "/admin/song/list",
        component: Listsong
    },
    {
        path: "/admin/song/add",
        component: Addsong
    },
    {
        path: "/admin/song/class",
        component: Classsong
    },
    //积分商城
    {
        path: "/admin/shop/list",
        component: Listshop
    },
    {
        path: "/admin/shop/add",
        component: Addshop
    },
    //设置
    {
        path: "/admin/setting/page",
        component: Pagesetting
    },
    {
        path: "/admin/setting/title",
        component: Titlesetting
    },
    {
        path: "/admin/setting/bilibili",
        component: BilibiliLogin
    },
    //反馈
    {
        path: "/admin/Feedback",
        component: Feedback
    },
    //兑换信息
    {
        path: "/admin/Exchange",
        component: Exchange
    },
    //小黑屋
    {
        path: "/admin/black/add",
        component: Blackadd
    },
    {
        path: "/admin/black/list",
        component: Blacklist
    },
    //路灯
    {
        path: "/admin/lamp/add",
        component: lampadd
    },
    {
        path: "/admin/lamp/list",
        component: lamplist
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFound,
    }
]

// 统一给 /admin 下的路由打上「需要管理员」标记：
// checkPermission() 读的就是这个字段，之前 25 条后台路由一条都没写，
// 导致权限判断恒为 true（等于没判）。这里自动打标，以后新增后台路由也不用逐条手加。
routes.forEach(route => {
    if (typeof route.path === 'string' && (route.path === '/admin' || route.path.startsWith('/admin/'))) {
        route.requireAdmin = true
    }
})





export default routes